// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "calendar-10v40";
export { _1 as "__esModule", _2 as "calendar" }
export default { "__esModule": _1, "calendar": _2 }
